module.exports = __webpack_public_path__ + "static/bootstrap-button-group-vertical-b6d39112f8f4d3f88bfc1562ced9cb2b.png";